module.exports = __webpack_public_path__ + "img/type1.3bd0528e.png";